import { Axios } from 'utils'
import { GenericResult } from './types'

export const useAdminService = () => {
  const getDeliveriesNames = async (companyId: string) => {
    try {
      const response = await Axios.get<GenericResult>(
        `deliveries/get_deliveries_names/${companyId}`,
        {
          responseType: 'blob',
        }
      )
      return response
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    getDeliveriesNames,
  }
}

export default useAdminService
